import { ReactNode } from 'react';

/**
 * Converts text with backticks into text with italic elements
 * Example: "Hello `world`" becomes "Hello <i>world</i>"
 */
export const formatTextWithItalics = (text: string): ReactNode => {
  // Check if text contains backticks
  if (!text.includes('`')) return text;
  
  // Split the text by backticks
  const parts = text.split('`');
  const result: ReactNode[] = [];
  
  // Alternate between normal and italic text
  parts.forEach((part, index) => {
    if (index % 2 === 0) {
      // Even indices are regular text
      result.push(part);
    } else {
      // Odd indices should be italic
      result.push(<i key={index}>{part}</i>);
    }
  });
  
  return result;
};